import { ReactComponent as ArrowVipIcon } from "./arrow-vip.svg";
import DefaultAvatar from "./avatar-default.png";
import { ReactComponent as DepositIcon } from "./deposit.svg";
import { ReactComponent as FacebookIcon } from "./facebook.svg";
import { ReactComponent as GlobeIcon } from "./globe.svg";
import { ReactComponent as HeartIcon } from "./icon_heart.svg";
import { ReactComponent as HeartOutlineIcon } from "./icon_heart-outline.svg";
import { ReactComponent as QrIcon } from "./qr.svg";
import { ReactComponent as IconQROffline } from "./qr-code.svg";
import { ReactComponent as RefreshIcon } from "./refresh.svg";
import { ReactComponent as TelegramIcon } from "./telegram.svg";
import { ReactComponent as UploadFileIcon } from "./upload.svg";
import { ReactComponent as WithdrawIcon } from "./withdraw.svg";
import { ReactComponent as YoutubeIcon } from "./youtube.svg";

export { ReactComponent as IconDeposit } from "assets/common/icons/icon_deposit-mobile.svg";
export { ReactComponent as IconWithdraw } from "assets/common/icons/icon_withdraw-mobile.svg";

export const CommonIcons = {
  Facebook: FacebookIcon,
  Youtube: YoutubeIcon,
  Telegram: TelegramIcon,
  Deposit: DepositIcon,
  Withdraw: WithdrawIcon,
  Refresh: RefreshIcon,
  DefaultAvatar: DefaultAvatar,
  HeartOutline: HeartOutlineIcon,
  Heart: HeartIcon,
  QrIcon: QrIcon,
  UploadFileIcon: UploadFileIcon,
  ArrowVipIcon: ArrowVipIcon,
  QROfflineIcon: IconQROffline,
  GlobeIcon: GlobeIcon,
};
